<a [id]='node.id'
  (click)="navigate(node, $event)"
  (mousedown)="handleMousedown(node, $event)"
  [innerHTML]="node.label"
  [ngClass]="{'menu-active': node.active, disabled: node.isDisabled}"></a>